import { render } from "./ReasonView.vue?vue&type=template&id=62640f06&scoped=true&ts=true"
import script from "./ReasonView.vue?vue&type=script&lang=ts"
export * from "./ReasonView.vue?vue&type=script&lang=ts"

import "./ReasonView.vue?vue&type=style&index=0&id=62640f06&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62640f06"]])

export default __exports__